module.exports = __webpack_public_path__ + "static/img/important3.9085d0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/important3.png
// module id = xbuk
// module chunks = 1